import React, { useEffect, useState } from "react";
import { SearchTypeEnum } from "@components/YhPageHeader/Types";
import { YhPageHeader } from "@components/YhPageHeader";
import { StatusDs } from "@src/types/FmsDs";
import { useLogModel } from "../logModel";
import { userService } from "../../auth/user/UserService";
export function PageHeader() {
    const {
        searchParam,
        onReset,
        onSearch,
        loadData,
        updateSearchParam,
    } = useLogModel();
    const [list, setList] = useState<any>([])


// const searchFields = [
//     {
//         type: SearchTypeEnum.Input,
//         xxl: 4,
//         span: 4,
//         placeholder: "应用名称",
//         fieldName: "name",
//         size: "small",
//         disabled: false
//     },
//     {
//         type: SearchTypeEnum.Select,
//         xxl: 4,
//         span: 4,
//         placeholder: "所属事业部",
//         fieldName: "code",
//         size: "small",
//         disabled: false,
//         option: []
//     },
//     {
//         type: SearchTypeEnum.Select,
//         xxl: 4,
//         span: 4,
//         placeholder: "所属机构",
//         fieldName: "branch",
//         size: "small",
//         disabled: false,
//         options: []
//     },



// ]

const fetchUserList = async (value: string) => {
    // if (!value) return await fn();
    let data = { page: {pageSize: -1, pageNum: 1}, name: value };
    return userService.findUserDetail(data).then(res => {
        const { retData: { records } } = res;
        let newList=records ? records.map(item => ({
            ...item,
            label: item.name,
            value: item.code,
        })) : [];
        setList(newList)
    })
}
useEffect(() => {
    fetchUserList("")
}, [])
const searchFields:any = [
    {
        type: SearchTypeEnum.Select,
        xxl: 4,
        span: 4,
        placeholder: "选择成员",
        fieldName: "userCode",
        size: "small",
        disabled: false,
        options: list
    },

]

    return (
        <YhPageHeader
            title="系统日志"
            searchValues={searchParam}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={onReset}
        />
    );
}